module.exports = __webpack_public_path__ + "img/living.787c3502.svg";